(function() {
  'use strict';

  /* ========================
     CART AJAX
     ======================== */
  const Cart = {
    async add(variantId, qty = 1) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      if (!res.ok) throw new Error('Add to cart failed');
      const item = await res.json();
      window.dispatchEvent(new CustomEvent('casey:cart:updated', { detail: item }));
      return item;
    },
    async change(lineKey, qty) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: qty })
      });
      if (!res.ok) throw new Error('Cart change failed');
      const cart = await res.json();
      window.dispatchEvent(new CustomEvent('casey:cart:updated'));
      return cart;
    },
    async get() {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      return res.json();
    }
  };
  window.CaseyCart = Cart;

  /* ========================
     HEADER SCROLL
     ======================== */
  function initHeader() {
    const header = document.getElementById('cz-header');
    if (!header) return;

    const isHeroPage = document.body.classList.contains('is-hero-page');

    if (isHeroPage) {
      const onScroll = () => {
        if (window.scrollY > 72) {
          header.classList.add('is-scrolled');
        } else {
          header.classList.remove('is-scrolled');
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    } else {
      header.classList.add('is-scrolled');
    }
  }

  /* ========================
     ANNOUNCEMENT BAR
     ======================== */
  function initAnnouncement() {
    const msgs = document.querySelectorAll('.cz-announce__msg');
    if (msgs.length < 2) return;
    let idx = 0;
    msgs[0].classList.add('is-active');
    setInterval(() => {
      msgs[idx].classList.remove('is-active');
      idx = (idx + 1) % msgs.length;
      msgs[idx].classList.add('is-active');
    }, 3200);
  }

  /* ========================
     MEGA MENU
     ======================== */
  function initMega() {
    const trigger = document.querySelector('[data-mega-trigger]');
    const mega = document.getElementById('cz-mega');
    if (!trigger || !mega) return;

    let timeout;
    const open = () => { clearTimeout(timeout); mega.classList.add('is-open'); mega.setAttribute('aria-hidden', 'false'); };
    const close = () => { timeout = setTimeout(() => { mega.classList.remove('is-open'); mega.setAttribute('aria-hidden', 'true'); }, 120); };

    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('mouseleave', close);
    mega.addEventListener('mouseenter', open);
    mega.addEventListener('mouseleave', close);
  }

  /* ========================
     SCROLL LOCK (iOS-safe)
     ======================== */
  var _lockScrollY = 0;
  function lockScroll() {
    _lockScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + _lockScrollY + 'px';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }
  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, _lockScrollY);
  }

  /* ========================
     DRAWERS & OVERLAYS
     ======================== */
  function initDrawers() {
    const backdrop = document.getElementById('cz-backdrop');
    const navDrawer = document.getElementById('cz-nav-drawer');
    const cartDrawer = document.getElementById('cz-cart-drawer');
    const searchOverlay = document.getElementById('cz-search-overlay');
    const clubOverlay = document.getElementById('cz-club-overlay');
    const addedFlyout = document.getElementById('cz-added-flyout');

    // Track which element opened a panel so focus can return to it
    let lastOpener = null;

    function panelOpen() {
      if (navDrawer && navDrawer.classList.contains('is-open')) return navDrawer;
      if (cartDrawer && cartDrawer.classList.contains('is-open')) return cartDrawer;
      if (searchOverlay && searchOverlay.classList.contains('is-open')) return searchOverlay;
      if (clubOverlay && clubOverlay.classList.contains('is-visible')) return clubOverlay;
      return null;
    }

    const FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

    // Keep Tab inside the open panel; Escape closes it.
    document.addEventListener('keydown', e => {
      const panel = panelOpen();
      if (!panel) return;

      if (e.key === 'Escape') {
        e.preventDefault();
        closeAll();
        return;
      }
      if (e.key !== 'Tab') return;

      const items = Array.from(panel.querySelectorAll(FOCUSABLE))
        .filter(el => el.offsetParent !== null || el === document.activeElement);
      if (!items.length) return;

      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (!panel.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      }
    });

    function closeAll() {
      const wasOpen = panelOpen();
      if (navDrawer) navDrawer.classList.remove('is-open');
      if (cartDrawer) cartDrawer.classList.remove('is-open');
      if (searchOverlay) searchOverlay.classList.remove('is-open');
      if (clubOverlay) clubOverlay.classList.remove('is-visible');
      if (backdrop) backdrop.classList.remove('is-visible');
      unlockScroll();
      if (wasOpen && lastOpener && typeof lastOpener.focus === 'function') {
        lastOpener.focus();
        lastOpener = null;
      }
    }

    function openPanel(panel, opener) {
      closeAll();
      lastOpener = opener || null;
      if (panel) panel.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-visible');
      lockScroll();
      if (panel) {
        const firstItem = panel.querySelector(FOCUSABLE);
        if (firstItem) setTimeout(() => firstItem.focus(), 60);
      }
    }

    // Burger
    const burger = document.getElementById('cz-burger');
    if (burger && navDrawer) {
      burger.addEventListener('click', () => openPanel(navDrawer, burger));
    }

    // Cart buttons
    const cartBtns = document.querySelectorAll('#cz-cart-btn, #cz-cart-mob');
    cartBtns.forEach(btn => {
      btn.addEventListener('click', () => openPanel(cartDrawer, btn));
    });

    // Search buttons
    const searchBtns = document.querySelectorAll('#cz-search-btn, #cz-search-mob');
    searchBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        closeAll();
        lastOpener = btn;
        if (searchOverlay) searchOverlay.classList.add('is-open');
        if (backdrop) backdrop.classList.add('is-visible');
        lockScroll();
        const input = searchOverlay.querySelector('.cz-search__input');
        if (input) setTimeout(() => input.focus(), 100);
      });
    });

    // Mobile nav collections accordion
    const collToggle = document.getElementById('cz-nav-coll-toggle');
    const collAcc = document.getElementById('cz-nav-coll-acc');
    if (collToggle && collAcc) {
      collToggle.addEventListener('click', () => {
        const open = collAcc.classList.toggle('is-open');
        collToggle.setAttribute('aria-expanded', String(open));
        const sign = collToggle.querySelector('.cz-nav-drawer__toggle-sign');
        if (sign) sign.textContent = open ? '−' : '+';
      });
    }

    // Casey+ club — all triggers
    document.querySelectorAll('[data-club-open]').forEach(btn => {
      btn.addEventListener('click', () => {
        if (clubOverlay) clubOverlay.classList.add('is-visible');
      });
    });
    const clubClose = document.querySelectorAll('#cz-club-close, #cz-club-x');
    clubClose.forEach(btn => {
      btn.addEventListener('click', () => {
        localStorage.setItem('casey_club_seen', '1');
        if (clubOverlay) clubOverlay.classList.remove('is-visible');
      });
    });

    // Casey+ club form submission → Shopify newsletter endpoint
    const clubEmail = clubOverlay ? clubOverlay.querySelector('.cz-club__email') : null;
    const clubJoinBtn = clubOverlay ? clubOverlay.querySelector('.cz-club__form-btn') : null;
    if (clubEmail && clubJoinBtn) {
      function submitClub() {
        const email = clubEmail.value.trim();
        const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        clubEmail.classList.toggle('cz-club__email--error', !valid);
        if (!valid) { clubEmail.focus(); return; }
        const orig = clubJoinBtn.textContent;
        clubJoinBtn.disabled = true;
        clubJoinBtn.textContent = '…';
        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
          body: 'form_type=customer&utf8=%E2%9C%93&contact%5Bemail%5D=' + encodeURIComponent(email) + '&contact%5Btags%5D=newsletter%2Ccasey-plus'
        }).then(() => {
          const formEl = clubEmail.closest('.cz-club__form');
          if (formEl) formEl.innerHTML = '<p class="cz-club__success">Thank you for joining Casey+! Check your email inbox — your exclusive discount code is on its way.</p>';
          localStorage.setItem('casey_club_seen', '1');
          localStorage.setItem('casey_club_member', '1');
          setTimeout(() => { if (clubOverlay) clubOverlay.classList.remove('is-visible'); }, 4000);
        }).catch(() => {
          clubJoinBtn.disabled = false;
          clubJoinBtn.textContent = orig;
        });
      }
      clubJoinBtn.addEventListener('click', submitClub);
      clubEmail.addEventListener('keydown', e => { if (e.key === 'Enter') submitClub(); });
    }

    // Close buttons
    document.querySelectorAll('.cz-drawer__close, .cz-cart-drawer__close, .cz-search__close').forEach(btn => {
      btn.addEventListener('click', closeAll);
    });

    // Backdrop click
    if (backdrop) backdrop.addEventListener('click', closeAll);

    // Added flyout
    if (addedFlyout) {
      const closeAdded = document.getElementById('cz-added-close');
      if (closeAdded) closeAdded.addEventListener('click', () => addedFlyout.classList.remove('is-visible'));
    }

    // Auto show Casey+ after 5s
    if (clubOverlay && !localStorage.getItem('casey_club_seen')) {
      setTimeout(() => clubOverlay.classList.add('is-visible'), 5000);
    }


  }

  /* ========================
     CART DRAWER RENDER
     ======================== */
  function initCartDrawer() {
    const drawer = document.getElementById('cz-cart-drawer');
    if (!drawer) return;

    var _cartBusy = false;

    async function renderCart() {
      const cart = await Cart.get();

      // Update header badges
      const headerCount = document.getElementById('cz-header-cart-count');
      const mobBadge = document.getElementById('cz-mob-cart-badge');
      const drawerTitle = drawer.querySelector('.cz-cart-drawer__title');

      if (headerCount) {
        headerCount.textContent = cart.item_count;
        headerCount.style.display = cart.item_count > 0 ? '' : 'none';
      }
      if (mobBadge) mobBadge.textContent = cart.item_count;
      if (drawerTitle) drawerTitle.textContent = 'My cart (' + cart.item_count + ')';

      // Shipping bar
      const threshold = parseInt(document.body.dataset.freeShipping || '5000');
      const pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      const remaining = ((threshold - cart.total_price) / 100).toFixed(2);
      const shipLabel = drawer.querySelector('.cz-cart-drawer__ship-label');
      const shipVal = drawer.querySelector('.cz-cart-drawer__ship-val');
      const shipFill = drawer.querySelector('.cz-cart-drawer__ship-fill');

      if (shipLabel) shipLabel.textContent = pct >= 100 ? 'Free EU shipping unlocked!' : '€' + remaining + ' away from free shipping';
      if (shipVal) shipVal.textContent = '€' + (cart.total_price / 100).toFixed(2) + ' / €' + (threshold / 100).toFixed(2);
      if (shipFill) shipFill.style.width = pct + '%';

      // Line items
      const itemsContainer = drawer.querySelector('.cz-cart-drawer__items');
      if (itemsContainer) {
        if (cart.items.length === 0) {
          itemsContainer.innerHTML = '<p style="padding:40px 0;text-align:center;font-size:14px;font-weight:500;color:#9A9AA0">Your cart is empty</p>';
        } else {
          itemsContainer.innerHTML = cart.items.map(function(item) {
            var imgSrc = item.image ? item.image.replace(/(\.\w+)\?/, '$1?width=200&') : '';
            return '<div class="cz-cart-drawer__item">' +
              '<div class="cz-cart-drawer__item-img"><img src="' + imgSrc + '" alt="' + item.title + '" width="96" height="116"></div>' +
              '<div class="cz-cart-drawer__item-body">' +
                '<div class="cz-cart-drawer__item-top">' +
                  '<div class="cz-cart-drawer__item-name">' + item.product_title + '</div>' +
                  '<button class="cz-cart-drawer__item-remove" data-line-key="' + item.key + '" aria-label="Remove">×</button>' +
                '</div>' +
                '<div class="cz-cart-drawer__item-variant">' + (item.variant_title || '') + '</div>' +
                '<div class="cz-cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>' +
                '<div class="cz-cart-drawer__qty"><div class="cz-cart-drawer__qty-wrap">' +
                  '<button class="cz-cart-drawer__qty-btn" data-qty-change="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
                  '<span class="cz-cart-drawer__qty-val">' + item.quantity + '</span>' +
                  '<button class="cz-cart-drawer__qty-btn" data-qty-change="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
                '</div></div>' +
              '</div>' +
            '</div>';
          }).join('');
        }

        function lockCartButtons() {
          itemsContainer.querySelectorAll('[data-qty-change], .cz-cart-drawer__item-remove').forEach(function(b) {
            b.disabled = true;
            b.style.opacity = '0.35';
          });
        }

        // Remove listeners
        itemsContainer.querySelectorAll('.cz-cart-drawer__item-remove').forEach(function(btn) {
          btn.addEventListener('click', async function() {
            if (_cartBusy) return;
            _cartBusy = true;
            lockCartButtons();
            try {
              await Cart.change(btn.dataset.lineKey, 0);
            } catch(e) { /* silent */ } finally {
              _cartBusy = false;
            }
          });
        });

        // Qty listeners
        itemsContainer.querySelectorAll('[data-qty-change]').forEach(function(btn) {
          btn.addEventListener('click', async function() {
            if (_cartBusy) return;
            _cartBusy = true;
            lockCartButtons();
            try {
              await Cart.change(btn.dataset.qtyChange, parseInt(btn.dataset.qty));
            } catch(e) { /* silent */ } finally {
              _cartBusy = false;
            }
          });
        });
      }

      // Subtotal
      var subtotalEl = drawer.querySelector('.cz-cart-drawer__subtotal-val');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    }

    window.addEventListener('casey:cart:updated', renderCart);
    renderCart();
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2);
  }

  /* ========================
     QUICK ADD TO CART
     ======================== */
  function initQuickAdd() {
    document.addEventListener('click', async function(e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.dataset.quickAdd;
      if (!variantId) return;

      var span = btn.querySelector('.cz-quickadd__text');
      if (span) span.textContent = 'Adding...';
      try {
        var item = await Cart.add(variantId);

        // Show added flyout
        var flyout = document.getElementById('cz-added-flyout');
        if (flyout) {
          var img = flyout.querySelector('#cz-added-img');
          var name = flyout.querySelector('#cz-added-name');
          if (img && item.image) img.src = item.image;
          if (name) name.textContent = item.product_title;
          flyout.classList.add('is-visible');
          setTimeout(function() { flyout.classList.remove('is-visible'); }, 4000);
        }

        // Open cart drawer (desktop only — mobile shows flyout only)
        var cartDrawer = document.getElementById('cz-cart-drawer');
        var backdrop = document.getElementById('cz-backdrop');
        if (cartDrawer && !window.matchMedia('(hover: none)').matches) {
          cartDrawer.classList.add('is-open');
          if (backdrop) backdrop.classList.add('is-visible');
          lockScroll();
        }
      } catch (err) { /* silent */ }
      if (span) span.textContent = 'Add to cart';
    });
  }

  /* ========================
     WISHLIST (requires login)
     ======================== */
  function initWishlist() {
    var KEY = 'casey_wishlist';
    var loggedIn = document.body.hasAttribute('data-customer-logged-in');

    function getWishlist() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch(e) { return []; }
    }

    function updateBadges() {
      var count = loggedIn ? getWishlist().length : 0;
      var badge = document.getElementById('cz-wish-badge');
      if (badge) {
        badge.textContent = count;
        badge.style.display = count > 0 ? '' : 'none';
      }
    }

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-wishlist-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      if (!loggedIn) {
        window.location.href = '/account/login?return_to=/pages/wishlist';
        return;
      }

      var handle = btn.dataset.wishlistAdd;
      var list = getWishlist();
      var idx = list.indexOf(handle);
      if (idx === -1) {
        list.push(handle);
      } else {
        list.splice(idx, 1);
      }
      localStorage.setItem(KEY, JSON.stringify(list));
      updateBadges();
    });

    updateBadges();
  }

  /* ========================
     COOKIE BANNER
     ======================== */
  function initCookie() {
    var banner = document.getElementById('cz-cookie');
    if (!banner) return;
    if (localStorage.getItem('casey_cookie')) return;

    setTimeout(function() { banner.classList.add('is-visible'); }, 1200);

    var accept = document.getElementById('cz-cookie-accept');
    var decline = document.getElementById('cz-cookie-decline');

    function dismiss(val) {
      localStorage.setItem('casey_cookie', val);
      banner.classList.remove('is-visible');
    }

    if (accept) accept.addEventListener('click', function() { dismiss('1'); });
    if (decline) decline.addEventListener('click', function() { dismiss('0'); });
  }

  /* ========================
     HORIZONTAL RAIL DRAG
     ======================== */
  function initRails() {
    document.querySelectorAll('.cz-rail').forEach(function(rail) {
      var isDown = false, startX = 0, scrollLeft = 0;

      rail.addEventListener('mousedown', function(e) {
        isDown = true;
        startX = e.pageX - rail.offsetLeft;
        scrollLeft = rail.scrollLeft;
        rail.style.cursor = 'grabbing';
      });
      rail.addEventListener('mouseleave', function() { isDown = false; rail.style.cursor = 'grab'; });
      rail.addEventListener('mouseup', function() { isDown = false; rail.style.cursor = 'grab'; });
      rail.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - rail.offsetLeft;
        rail.scrollLeft = scrollLeft - (x - startX) * 1.4;
      }, { passive: false });
    });

    // Arrow buttons
    document.querySelectorAll('[data-rail-prev]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var rail = document.getElementById(btn.dataset.railPrev);
        if (rail) rail.scrollBy({ left: -(rail.clientWidth * 0.8), behavior: 'smooth' });
      });
    });
    document.querySelectorAll('[data-rail-next]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var rail = document.getElementById(btn.dataset.railNext);
        if (rail) rail.scrollBy({ left: rail.clientWidth * 0.8, behavior: 'smooth' });
      });
    });

    // Arrows: always visible on desktop (dim at boundary), hide at boundary on mobile
    document.querySelectorAll('[data-rail]').forEach(function(rail) {
      if (!rail.id) return;
      var prev = document.querySelector('[data-rail-prev="' + rail.id + '"]');
      var next = document.querySelector('[data-rail-next="' + rail.id + '"]');
      if (!prev && !next) return;
      function update() {
        var isDesktop = window.innerWidth > 768;
        var atStart = rail.scrollLeft < 10;
        var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 10;
        if (isDesktop) {
          if (prev) { prev.style.display = 'flex'; prev.style.opacity = atStart ? '0.35' : '1'; }
          if (next) { next.style.display = 'flex'; next.style.opacity = atEnd ? '0.35' : '1'; }
        } else {
          if (prev) prev.style.display = 'none';
          if (next) next.style.display = 'none';
        }
      }
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });

    // Progress bars
    document.querySelectorAll('[data-rail-progress]').forEach(function(bar) {
      var rail = document.getElementById(bar.dataset.railProgress);
      var fill = bar.querySelector('.cz-rail__progress-fill');
      if (!rail || !fill) return;
      function updateProgress() {
        var max = rail.scrollWidth - rail.clientWidth;
        if (max <= 0) { fill.style.width = '0%'; return; }
        var pct = Math.min(100, Math.max(0, (rail.scrollLeft / max) * 100));
        fill.style.width = pct + '%';
      }
      rail.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();
    });
  }

  /* ========================
     PDP GALLERY
     ======================== */
  function initPdpGallery() {
    var gallery = document.querySelector('.cz-pdp__gallery');
    if (!gallery) return;

    var mainImg = gallery.querySelector('.cz-pdp__main-img img');
    var thumbs = gallery.querySelectorAll('.cz-pdp__thumb');
    var counter = gallery.querySelector('.cz-pdp__counter');
    var prevBtn = gallery.querySelector('.cz-pdp__arrow--prev');
    var nextBtn = gallery.querySelector('.cz-pdp__arrow--next');

    if (!mainImg || thumbs.length === 0) return;

    thumbs.forEach(function(t) { var p = new Image(); p.src = t.dataset.src; });

    var currentIdx = 0;
    var total = thumbs.length;

    function goTo(idx) {
      currentIdx = ((idx % total) + total) % total;
      var src = thumbs[currentIdx].dataset.src;
      // The srcset must be swapped too: while a srcset is present, Safari keeps
      // showing the candidate it already picked and ignores a new src.
      var srcset = thumbs[currentIdx].dataset.srcset;
      if (srcset) {
        mainImg.srcset = srcset;
      } else {
        mainImg.removeAttribute('srcset');
      }
      mainImg.src = src;
      thumbs.forEach(function(t, i) { t.classList.toggle('is-active', i === currentIdx); });
      if (counter) counter.textContent = (currentIdx + 1) + ' / ' + total;
    }

    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() { goTo(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(currentIdx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(currentIdx + 1); });

    // Swipe left/right on the main image (mobile — arrows are hidden there).
    // Listeners are passive and never block the page's vertical scrolling.
    var mainWrap = gallery.querySelector('.cz-pdp__main-img');
    if (mainWrap && total > 1) {
      var startX = 0, startY = 0, tracking = false;

      mainWrap.addEventListener('touchstart', function(e) {
        if (e.touches.length !== 1) { tracking = false; return; }
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });

      mainWrap.addEventListener('touchend', function(e) {
        if (!tracking) return;
        tracking = false;
        var touch = e.changedTouches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        // Only act on a clearly horizontal swipe, so scrolling the page still works.
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          goTo(dx < 0 ? currentIdx + 1 : currentIdx - 1);
        }
      }, { passive: true });
    }

    goTo(0);
  }

  /* ========================
     PDP STICKY BAR
     ======================== */
  function initPdpSticky() {
    var sticky = document.querySelector('.cz-pdp-sticky');
    if (!sticky) return;

    window.addEventListener('scroll', function() {
      if (window.scrollY > 520) {
        sticky.classList.add('is-visible');
      } else {
        sticky.classList.remove('is-visible');
      }
    }, { passive: true });
  }

  /* ========================
     ACCORDIONS
     ======================== */
  function initAccordions() {
    document.querySelectorAll('.cz-accordion__trigger').forEach(function(trigger) {
      var body = trigger.nextElementSibling;
      if (trigger.getAttribute('aria-expanded') === 'true' && body) {
        body.classList.add('is-open');
      }
      trigger.addEventListener('click', function() {
        var sign = trigger.querySelector('.cz-accordion__sign');
        var isOpen = body.classList.contains('is-open');
        body.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (sign) sign.textContent = isOpen ? '+' : '−';
      });
    });
  }

  /* ========================
     COLLECTION SWIMLANE TABS
     ======================== */
  function initSwimlaneTabs() {
    var tabs = document.querySelectorAll('[data-swimlane-tab]');
    var panels = document.querySelectorAll('[data-swimlane-panel]');
    if (tabs.length === 0) return;

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = tab.dataset.swimlaneTab;
        tabs.forEach(function(t) { t.classList.toggle('is-active', t === tab); });
        panels.forEach(function(p) { p.style.display = p.dataset.swimlanePanel === target ? '' : 'none'; });
      });
    });
  }

  /* ========================
     SEARCH PREDICTIVE
     ======================== */
  function initSearch() {
    var overlay = document.getElementById('cz-search-overlay');
    if (!overlay) return;

    var input = overlay.querySelector('.cz-search__input');
    var results = overlay.querySelector('.cz-search__results');
    if (!input || !results) return;

    var debounce;
    input.addEventListener('input', function() {
      clearTimeout(debounce);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      debounce = setTimeout(async function() {
        try {
          var res = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6');
          var data = await res.json();
          var products = data.resources.results.products || [];
          if (products.length === 0) {
            results.innerHTML = '<p style="font-size:14px;color:#9A9AA0;font-weight:500">No results found</p>';
            return;
          }
          results.innerHTML = products.map(function(p) {
            return '<a href="' + p.url + '" style="text-decoration:none;color:inherit;display:block">' +
              '<div style="background:#EFEFF0;aspect-ratio:4/5;overflow:hidden;margin-bottom:9px">' +
                '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy" style="width:100%;height:100%;object-fit:cover">' +
              '</div>' +
              '<div style="font-size:13px;font-weight:700">' + p.title + '</div>' +
              '<div style="font-size:12px;font-weight:600;color:#6B6B72;margin-top:4px">' + p.price + '</div>' +
            '</a>';
          }).join('');
        } catch(err) { /* silent */ }
      }, 300);
    });
  }

  /* ========================
     PRODUCT FORM (ATC AJAX)
     ======================== */
  function initProductForm() {
    var form = document.getElementById('cz-product-form');
    if (!form) return;

    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      var variantId = document.getElementById('cz-variant-id');
      var atc = document.getElementById('cz-atc');
      if (!variantId || !variantId.value) return;

      var originalText = atc ? atc.textContent.trim() : '';
      if (atc) { atc.textContent = 'Adding...'; atc.disabled = true; }

      try {
        await Cart.add(parseInt(variantId.value));
        if (atc) {
          atc.classList.add('is-added');
          atc.textContent = '✓ Added to cart';
          atc.disabled = false;
          setTimeout(function() {
            atc.classList.remove('is-added');
            atc.textContent = originalText;
          }, 1800);
        }
      } catch(err) {
        if (atc) { atc.disabled = false; atc.textContent = originalText; }
      }
    });

    var stickyBtn = document.getElementById('cz-sticky-atc-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        var atc = document.getElementById('cz-atc');
        if (atc) atc.click();
      });
    }
  }

  /* ========================
     VARIANT PICKER
     ======================== */
  function initVariantPicker() {
    var form = document.getElementById('cz-product-form');
    if (!form) return;

    var variantsEl = document.getElementById('cz-product-variants');
    if (!variantsEl) return;

    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch(e) { return; }

    var selects = form.querySelectorAll('[data-option-position]');
    if (!selects.length) return;

    var hiddenId = document.getElementById('cz-variant-id');
    var atcBtn = document.getElementById('cz-atc');
    var priceEl = document.getElementById('cz-price');
    var compareEl = document.getElementById('cz-compare-price');
    var stickyPrice = document.getElementById('cz-sticky-price');
    var stockNote = document.getElementById('cz-stock-note');

    function fmt(cents) {
      return '€' + (cents / 100).toFixed(2);
    }

    function findVariant() {
      var selected = [];
      selects.forEach(function(s) { selected.push(s.value); });
      if (selected.some(function(v) { return !v; })) return null;
      return variants.find(function(v) {
        return v.options.every(function(opt, i) { return selected[i] === opt; });
      }) || null;
    }

    function update() {
      var variant = findVariant();
      if (!variant) return;

      if (hiddenId) hiddenId.value = variant.id;

      var price = fmt(variant.price);
      if (priceEl) priceEl.textContent = price;
      if (stickyPrice) stickyPrice.textContent = price;

      // Compare-at price
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = fmt(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      // Stock status
      if (stockNote) {
        if (variant.available) {
          if (variant.inventory_management === 'shopify' && variant.inventory_quantity > 0 && variant.inventory_quantity <= 10) {
            stockNote.innerHTML = '<span class="cz-buybox__stock cz-buybox__stock--low">Only ' + variant.inventory_quantity + ' left — ships in 1–2 days</span>';
          } else if (variant.available) {
            stockNote.innerHTML = '<span class="cz-buybox__stock">✓ In stock — ships in 1–2 days</span>';
          }
        } else {
          stockNote.innerHTML = '<span class="cz-buybox__stock cz-buybox__stock--out">Sold out</span>';
        }
      }

      if (atcBtn) {
        if (variant.available) {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to cart — ' + price;
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Sold out';
        }
      }

      selects.forEach(function(sel) {
        // Update "Model: <value>" label
        var pos = sel.dataset.optionPosition;
        var valEl = form.querySelector('[data-option-val="' + pos + '"]');
        if (valEl && sel.value) valEl.textContent = sel.value;

        var instock = sel.closest('.cz-buybox__option') && sel.closest('.cz-buybox__option').querySelector('.cz-buybox__instock');
        if (instock) {
          if (sel.value && variant.available) {
            instock.textContent = '✓ ' + sel.value + ' — in stock';
            instock.style.display = '';
          } else {
            instock.style.display = 'none';
          }
        }
      });
    }

    selects.forEach(function(sel) { sel.addEventListener('change', update); });
  }

  /* ========================
     PDP SHIPPING BAR (live update)
     ======================== */
  function initShippingBar() {
    var bar = document.querySelector('.cz-buybox__shipping-bar');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold) || 5000;
    var fill = document.getElementById('cz-ship-fill');
    var msg = document.getElementById('cz-ship-msg');
    if (!fill || !msg) return;

    function updateBar(totalPrice) {
      var pct = Math.min(100, Math.round(totalPrice * 100 / threshold));
      fill.style.width = pct + '%';
      if (pct >= 100) {
        msg.textContent = 'Free EU shipping unlocked';
      } else {
        var remaining = ((threshold - totalPrice) / 100).toFixed(2);
        msg.textContent = 'Add €' + remaining + ' more for free EU shipping';
      }
    }

    window.addEventListener('casey:cart:updated', function() {
      Cart.get().then(function(cart) { updateBar(cart.total_price); }).catch(function() {});
    });
  }

  /* ========================
     COMMUNITY SLIDER PROGRESS
     ======================== */
  function initCommunitySlider() {
    var slider = document.querySelector('.cz-community__products');
    var fill = document.querySelector('.cz-community__progress-fill');
    if (!slider) return;

    var prevBtn = document.querySelector('[data-comm-prev]');
    var nextBtn = document.querySelector('[data-comm-next]');

    function updateFill() {
      if (!fill) return;
      var max = slider.scrollWidth - slider.clientWidth;
      if (max <= 0) return;
      var pct = Math.min(100, Math.max(0, (slider.scrollLeft / max) * 100));
      fill.style.width = pct + '%';
    }

    function updateArrows() {
      var isDesktop = window.innerWidth > 768;
      var atStart = slider.scrollLeft < 10;
      var atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 10;
      if (prevBtn) {
        if (isDesktop) { prevBtn.style.display = 'flex'; prevBtn.style.opacity = atStart ? '0.35' : '1'; }
        else { prevBtn.style.display = 'none'; }
      }
      if (nextBtn) {
        if (isDesktop) { nextBtn.style.display = 'flex'; nextBtn.style.opacity = atEnd ? '0.35' : '1'; }
        else { nextBtn.style.display = 'none'; }
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function() {
      slider.scrollBy({ left: -(slider.clientWidth * 0.8), behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function() {
      slider.scrollBy({ left: slider.clientWidth * 0.8, behavior: 'smooth' });
    });

    slider.addEventListener('scroll', updateFill, { passive: true });
    slider.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateFill);
    window.addEventListener('resize', updateArrows);
    updateFill();
    updateArrows();
  }

  /* ========================
     BACK TO TOP
     ======================== */
  function initBackToTop() {
    var btn = document.getElementById('cz-back-top');
    if (!btn) return;
    window.addEventListener('scroll', function() {
      if (window.scrollY > 600) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    }, { passive: true });
    btn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ========================
     INIT
     ======================== */
  function init() {
    initHeader();
    initAnnouncement();
    initMega();
    initDrawers();
    initCartDrawer();
    initQuickAdd();
    initWishlist();
    initCookie();
    initRails();
    initPdpGallery();
    initPdpSticky();
    initProductForm();
    initVariantPicker();
    initAccordions();
    initSwimlaneTabs();
    initSearch();
    initShippingBar();
    initCommunitySlider();
    initBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
